"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Typography = exports.InfoTextBold = exports.InfoText = exports.Subtitle = exports.Title = exports.Headline = exports.ButtonTypography = exports.ParagraphBold = exports.Paragraph = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _typography = require("@styled-system/typography");

var _Box = require("../Box");

var _baseStyle = require("../shared/baseStyle");

var _useCustomStyles = require("../utils/useCustomStyles");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var baseTypographyStyle = (0, _styledComponents.css)(["", " font-family:", ";font-style:normal;font-weight:", ";margin:0;", ""], _baseStyle.baseStyle, function (props) {
  return props.theme.typography.base.fontFamily;
}, function (props) {
  return props.theme.typography.base.fontWeight;
}, (0, _useCustomStyles.getCustomStyles)('typography.styles', 'root'));

var Paragraph = _styledComponents.default.p.withConfig({
  displayName: "Typography__Paragraph",
  componentId: "m2dlo8-0"
})(["", " font-size:", ";line-height:", ";margin-bottom:", ";", " ", " ", ""], baseTypographyStyle, function (props) {
  return props.theme.typography.paragraph.fontSize;
}, function (props) {
  return props.theme.typography.paragraph.lineHeight;
}, function (props) {
  return props.inline ? 0 : props.theme.typography.paragraph.marginBottom;
}, (0, _useCustomStyles.getCustomStyles)('typography.styles', 'paragraph'), _Box.boxInterpolateFn, _typography.typography);

exports.Paragraph = Paragraph;

var ParagraphBold = _styledComponents.default.p.withConfig({
  displayName: "Typography__ParagraphBold",
  componentId: "m2dlo8-1"
})(["", " font-size:", ";line-height:", ";font-weight:", ";margin-bottom:", ";", " ", " ", ""], baseTypographyStyle, function (props) {
  return props.theme.typography.paragraphBold.fontSize;
}, function (props) {
  return props.theme.typography.paragraphBold.lineHeight;
}, function (props) {
  return props.theme.typography.paragraphBold.fontWeight;
}, function (props) {
  return props.inline ? 0 : props.theme.typography.paragraphBold.marginBottom;
}, (0, _useCustomStyles.getCustomStyles)('typography.styles', 'paragraphBold'), _Box.boxInterpolateFn, _typography.typography);

exports.ParagraphBold = ParagraphBold;

var ButtonTypography = _styledComponents.default.span.withConfig({
  displayName: "Typography__ButtonTypography",
  componentId: "m2dlo8-2"
})(["", " font-size:", ";line-height:", ";margin-bottom:", ";", " ", " ", ""], baseTypographyStyle, function (props) {
  return props.theme.typography.button.fontSize;
}, function (props) {
  return props.theme.typography.button.lineHeight;
}, function (props) {
  return props.inline ? 0 : props.theme.typography.button.marginBottom;
}, (0, _useCustomStyles.getCustomStyles)('typography.styles', 'button'), _Box.boxInterpolateFn, _typography.typography);

exports.ButtonTypography = ButtonTypography;

var Headline = _styledComponents.default.h2.withConfig({
  displayName: "Typography__Headline",
  componentId: "m2dlo8-3"
})(["", " font-size:", ";line-height:", ";margin-bottom:", ";", " ", " ", ""], baseTypographyStyle, function (props) {
  return props.theme.typography.headline.fontSize;
}, function (props) {
  return props.theme.typography.headline.lineHeight;
}, function (props) {
  return props.inline ? 0 : props.theme.typography.headline.marginBottom;
}, (0, _useCustomStyles.getCustomStyles)('typography.styles', 'headline'), _Box.boxInterpolateFn, _typography.typography);

exports.Headline = Headline;

var Title = _styledComponents.default.h3.withConfig({
  displayName: "Typography__Title",
  componentId: "m2dlo8-4"
})(["", " font-size:", ";line-height:", ";margin-bottom:", ";", " ", " ", ""], baseTypographyStyle, function (props) {
  return props.theme.typography.title.fontSize;
}, function (props) {
  return props.theme.typography.title.lineHeight;
}, function (props) {
  return props.inline ? 0 : props.theme.typography.title.marginBottom;
}, (0, _useCustomStyles.getCustomStyles)('typography.styles', 'title'), _Box.boxInterpolateFn, _typography.typography);

exports.Title = Title;

var Subtitle = _styledComponents.default.h4.withConfig({
  displayName: "Typography__Subtitle",
  componentId: "m2dlo8-5"
})(["", " font-size:", ";line-height:", ";margin-bottom:", ";", " ", " ", ""], baseTypographyStyle, function (props) {
  return props.theme.typography.subtitle.fontSize;
}, function (props) {
  return props.theme.typography.subtitle.lineHeight;
}, function (props) {
  return props.inline ? 0 : props.theme.typography.subtitle.marginBottom;
}, (0, _useCustomStyles.getCustomStyles)('typography.styles', 'subtitle'), _Box.boxInterpolateFn, _typography.typography);

exports.Subtitle = Subtitle;

var InfoText = _styledComponents.default.p.withConfig({
  displayName: "Typography__InfoText",
  componentId: "m2dlo8-6"
})(["", " font-size:", ";line-height:", ";margin-bottom:", ";", " ", " ", ""], baseTypographyStyle, function (props) {
  return props.theme.typography.info.fontSize;
}, function (props) {
  return props.theme.typography.info.lineHeight;
}, function (props) {
  return props.inline ? 0 : props.theme.typography.info.marginBottom;
}, (0, _useCustomStyles.getCustomStyles)('typography.styles', 'info'), _Box.boxInterpolateFn, _typography.typography);

exports.InfoText = InfoText;

var InfoTextBold = _styledComponents.default.p.withConfig({
  displayName: "Typography__InfoTextBold",
  componentId: "m2dlo8-7"
})(["", " font-size:", ";line-height:", ";font-weight:", ";margin-bottom:", ";", " ", " ", ""], baseTypographyStyle, function (props) {
  return props.theme.typography.infoBold.fontSize;
}, function (props) {
  return props.theme.typography.infoBold.lineHeight;
}, function (props) {
  return props.theme.typography.infoBold.fontWeight;
}, function (props) {
  return props.inline ? 0 : props.theme.typography.infoBold.marginBottom;
}, (0, _useCustomStyles.getCustomStyles)('typography.styles', 'infoBold'), _Box.boxInterpolateFn, _typography.typography);

exports.InfoTextBold = InfoTextBold;
var Typography = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'paragraph' : _ref$variant,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["variant", "children"]);

  switch (variant) {
    case 'headline':
      return /*#__PURE__*/_react.default.createElement(Headline, _extends({
        ref: ref
      }, props), children);

    case 'title':
      return /*#__PURE__*/_react.default.createElement(Title, _extends({
        ref: ref
      }, props), children);

    case 'subtitle':
      return /*#__PURE__*/_react.default.createElement(Subtitle, _extends({
        ref: ref
      }, props), children);

    case 'paragraphBold':
      return /*#__PURE__*/_react.default.createElement(ParagraphBold, _extends({
        ref: ref
      }, props), children);

    case 'info':
      return /*#__PURE__*/_react.default.createElement(InfoText, _extends({
        ref: ref
      }, props), children);

    case 'infoBold':
      return /*#__PURE__*/_react.default.createElement(InfoTextBold, _extends({
        ref: ref
      }, props), children);

    case 'button':
      return /*#__PURE__*/_react.default.createElement(ButtonTypography, _extends({
        ref: ref
      }, props), children);

    case 'paragraph':
    default:
      return /*#__PURE__*/_react.default.createElement(Paragraph, _extends({
        ref: ref
      }, props), children);
  }
});
exports.Typography = Typography;